"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lincd = exports._ontology = exports.ns = exports.loadData = void 0;
const JSONLD_1 = require("lincd-jsonld/lib/utils/JSONLD");
const NameSpace_1 = require("lincd/lib/utils/NameSpace");
const package_1 = require("../package");
const _this = __importStar(require("./lincd"));
var loadData = () => JSONLD_1.JSONLD.parsePromise(Promise.resolve().then(() => __importStar(require('../data/lincd.json'))));
exports.loadData = loadData;
exports.ns = (0, NameSpace_1.createNameSpace)('https://purl.org/on/lincd/');
//Good practice to export a NamedNode for the ontology itself as well
exports._ontology = (0, exports.ns)('');
var Component = (0, exports.ns)('Component');
var Method = (0, exports.ns)('Method');
var Module = (0, exports.ns)('Module');
var OntologyFile = (0, exports.ns)('OntologyFile');
var ShapeClass = (0, exports.ns)('ShapeClass');
var definesShape = (0, exports.ns)('definesShape');
var exports_ = (0, exports.ns)('exports');
var hasMethod = (0, exports.ns)('hasMethod');
var methodOf = (0, exports.ns)('methodOf');
var module = (0, exports.ns)('module');
var dataFile_ = (0, exports.ns)('dataFile');
var ontology = (0, exports.ns)('ontology');
var prefix = (0, exports.ns)('prefix');
var usesShapeClass = (0, exports.ns)('usesShapeClass');
var ModuleExport = (0, exports.ns)('ModuleExport');
var NPM_Module = (0, exports.ns)('NPM_Module');
var npmPath = (0, exports.ns)('npmPath');
var title = (0, exports.ns)('title'); // NEW
// var accesses = ns('accesses');  - not yet implemented
// var exportedBy = ns('exportedBy');  - alias for lincd:module
// var requires = ns('requires');  - not yet implemented
exports.lincd = {
    Component,
    Method,
    Module,
    ModuleExport,
    OntologyFile,
    ShapeClass,
    dataFile: dataFile_,
    definesShape,
    exports: exports_,
    hasMethod,
    methodOf,
    module,
    ontology,
    prefix,
    usesShapeClass,
    NPM_Module,
    npmPath,
    title,
    // accesses,
    // exportedBy,
    // requires,
};
(0, package_1.linkedOntology)(_this, exports.ns, 'lincdm', exports.loadData, '../data/lincd.json');
//# sourceMappingURL=lincd.js.map